import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { APP_VERSION, checkVersion } from './config/version'

// Log app version
console.log(`🚀 Crux Real Estate Platform v${APP_VERSION}`);

// Check if version has changed (cache busting)
const isSameVersion = checkVersion();
if (!isSameVersion) {
  console.log('✨ New version loaded - caches cleared');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
